import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ApiService from '../../services/ApiService';

// Async thunks
export const fetchCartItems = createAsyncThunk('cart/fetchCartItems', async () => {
    const response = await ApiService.publicGetRequest('/cart/mycart', true);
    return response.data.data;
});

export const addToCart = createAsyncThunk('cart/addToCart', async ({ courseId, moduleList }) => {
    const response = await ApiService.publicPostRequest('/cart/addtocart', {
        course: {
            courseId,
            moduleList
        }
    }, true);
   
    return response.data;
});
export const updateCart = createAsyncThunk('cart/updatecart', async ({ cartId, courseId, moduleList }) => {
    const response = await ApiService.publicPostRequest('/cart/updatecart', {
        cartId,
        course: {
            courseId,
            moduleList
        }
    }, true);

    return response.data.data;
});

export const removeFromCart = createAsyncThunk('cart/removeFromCart', async (cartId) => {
    const response = await ApiService.publicDeleteRequest(`/cart/removefromcart/${cartId}`, true);
    return { cartId };
});

// Slice
const cartSlice = createSlice({
    name: 'cart',
    initialState: {
        items: [],
        cartPrice: 0,
        loading: false,
        error: null,
        cartItems: 0
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchCartItems.pending, (state) => {
                state.loading = true;
            })
            .addCase(fetchCartItems.fulfilled, (state, action) => {
                state.loading = false;
                state.items = action.payload?.cartResponseWOList || [];
                state.cartPrice = action.payload?.cartPrice || 0;
                state.cartItems = state.items.length;
            })
            .addCase(fetchCartItems.rejected, (state, action) => {
                state.loading = false;
                state.error = action.error.message;
            })
            .addCase(addToCart.fulfilled, (state, action) => {
                let res=action.payload;
                if(res.resultCode==1){
                    state.items.push(res.data);   
                    state.cartItems = state.items.length;
                }else{ 
                    state.error = res.message; 
                }
              

                // Recalculate cartPrice if needed
            })
            .addCase(updateCart.fulfilled, (state, action) => {
                state.items.push(action.payload);
                state.cartItems = state.items.length;

                // Recalculate cartPrice if needed
            })
            .addCase(removeFromCart.fulfilled, (state, action) => {
                const { cartId } = action.payload;
                state.items = state.items.filter(item => item.cartId !== cartId);
                state.cartItems = state.items.length;
                // Recalculate cartPrice if needed
            });
    }
});

export default cartSlice.reducer;
